import { PHONE_DISPLAY, PHONE_TEL } from '../../../lib/businessInfo';

export default function ConsultationCta() {
  return (
    <div className="bg-gradient-to-br from-[#1A2332] via-[#243040] to-[#1A2332] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Experience the Difference?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Let's talk about your next vehicle. No pressure, no games — just honest conversation about what you're looking for.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${PHONE_TEL}`}
              className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              {PHONE_DISPLAY}
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-message-3-line"></i>
              Send a Message
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
